import { useApi } from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { LoadingBlock, ErrorState } from "@/components/common/StateViews";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { GraduationCap, Sparkles, Users } from "lucide-react";

const PATTERNS = [
  { title: "Role → Task → Format", body: "State who the model should act as, the exact task, and the output format you want." },
  { title: "Give context up front", body: "Paste the source material or link a knowledge source before asking the question." },
  { title: "Constrain the output", body: "Set max length and a structure (bullets, table) to cut cost and improve quality." },
  { title: "Iterate, don't restart", body: "Refine within the same thread; after ~60 turns, summarise and start fresh." },
];

export default function Learn() {
  const { data: guides = [], isLoading, error } = useApi("guides", "/guides");
  if (error) return <ErrorState />;
  return (
    <div>
      <PageHeader eyebrow="Navitra Companion" title="Learn" subtitle="Build AI skill — prompt patterns, per-tool guides, internal champions and office hours." />
      <div className="grid lg:grid-cols-2 gap-4">
        <Card>
          <CardHeader><CardTitle className="font-display text-lg flex items-center gap-2"><Sparkles className="h-4 w-4 text-gold" />Prompt patterns</CardTitle></CardHeader>
          <CardContent className="space-y-3">{PATTERNS.map((p) => (
            <div key={p.title} className="rounded-lg border p-3"><p className="font-medium text-sm">{p.title}</p><p className="text-sm text-muted-foreground mt-1">{p.body}</p></div>
          ))}</CardContent>
        </Card>
        <Card>
          <CardHeader><CardTitle className="font-display text-lg flex items-center gap-2"><GraduationCap className="h-4 w-4 text-navy" />Short guides</CardTitle></CardHeader>
          <CardContent>
            {isLoading ? <LoadingBlock className="h-40" /> : (
              <div className="space-y-2">{guides.slice(0, 6).map((g) => (
                <div key={g.id} className="flex items-center justify-between rounded-lg border p-3"><span className="text-sm font-medium">{g.title}</span><Badge variant="outline" className="text-[10px]">{g.roles[0]}</Badge></div>
              ))}</div>
            )}
            <div className="mt-4 rounded-lg bg-muted/40 p-4 flex items-center gap-3"><Users className="h-5 w-5 text-navy" /><div><p className="text-sm font-medium">Office hours every Thursday</p><p className="text-xs text-muted-foreground">Meet the AI champions network · bring your use cases.</p></div></div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
